<script setup>
import {changeStep, saveCurrentStep, Steps} from "@/composables/ai-onboarding/useSteps";
import JobProcessingProgress from "@/components/ai-processing/JobProcessingProgress.vue";
import {StepSummaryConfig} from "@/composables/ai-onboarding/useAiStepSummaryConfig";
import {useMutation} from "@tanstack/vue-query";
import axios from "axios";
import MeetMyManagersModal from "@/components/ai-onboarding/modals/MeetMyManagersModal.vue";
import {onMounted, ref} from "vue";
import useUser from "@/composables/useUser";

const emit = defineEmits(['changeStep']);

const {mutate: acknowledgedProgressCompleted} = useMutation({
  mutationFn: () => axios.patch('/ajax/v2/strategy/mark-acknowledged-completion'),
  onSuccess: (_, failed) => {
    if (failed) {
      saveCurrentStep({key: 'completed'});
      window.location.reload();
      return;
    }

    changeStep(Steps.PAGES, emit);
  },
});

const emitNextStep = async (failed = false) => {
  acknowledgedProgressCompleted(failed);
}

const {isAdmin} = useUser();
const showMeetMyManagersModal = ref(false);
onMounted(async () => {
  setTimeout(() => {
    if (!isAdmin.value) {
      return;
    }
    showMeetMyManagersModal.value = true;
  }, 5000);
});
</script>

<template>
  <JobProcessingProgress
    :ai-summary-url-path="Steps.AI_AUTO_ASSIGN_HOLDING.aiSummaryUrlPath"
    data-url-path="/ajax/v2/strategy/auto-assign-jobs-progress"
    :step-summary-config="StepSummaryConfig"
    :job-percentage-weights="[10, 60]"
    hide-percentage
    @trigger-navigation-event="emitNextStep"
  >
    <template #progress-footer>
      <div class="tw-text-center tw-text-lg">
        <p>
          This process may take up to an hour, but it’s often completed sooner.
        </p>
        <p>
          Don’t worry, we’ll email you as soon as it’s done.
        </p>
      </div>
    </template>

    <template #modal>
      <MeetMyManagersModal
        v-if="showMeetMyManagersModal"
        @close="showMeetMyManagersModal = false"
      />
    </template>
  </JobProcessingProgress>
</template>
